export default __webpack_public_path__ + "static/media/rentSec.fc83a9dc.png";